import {
	DesktopContainerStylesProps,
	MobileContainerStylesProps,
	OptionStylesProps,
	OptionsContainerStylesProps,
} from './types';

import { Icon as UnstyledIcon } from 'features/common/components/Icon';
import styled from 'styled-components';

export const Icon = styled(UnstyledIcon)`
	cursor: pointer;
`;

export const IconFilter = styled(UnstyledIcon)`
	cursor: pointer;
`;

export const Container = styled.div<{ secondaryStyle?: boolean; isOpened: boolean; punchupStyle?: boolean }>`
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	height: 100%;
	padding: 5px 15px 5px 15px;
	border: ${({ theme, secondaryStyle, isOpened, punchupStyle }) =>
		punchupStyle
			? `1px solid ${theme.colors.grey20}`
			: isOpened && secondaryStyle
			? `0.5px solid ${theme.colors.green}`
			: `0.5px solid ${theme.colors.white}`};

	border-radius: ${({ isOpened }) => (isOpened ? '6px 6px 0px 0px' : '6px')};
	cursor: pointer;
`;

export const MobileContainer = styled.div<MobileContainerStylesProps>`
	display: block;
	flex-direction: ${({ responsiveSecondary }) => (responsiveSecondary ? 'row' : 'row-reverse')};
	flex-wrap: wrap;
	position: relative;
	font-family: ${({ theme }) => theme.fonts.primary};
	justify-content: ${({ responsiveSecondary }) => responsiveSecondary && 'space-around'};
	background-color: ${({ theme, responsiveSecondary }) => responsiveSecondary && theme.colors.grey2};
	border-radius: ${({ responsiveSecondary }) => responsiveSecondary && '4px'};
	margin-bottom: ${({ responsiveSecondary }) => responsiveSecondary && '32px'};
	align-items: ${({ responsiveSecondary }) => responsiveSecondary && 'center'};
	height: ${({ responsiveSecondary }) => !responsiveSecondary && '25px'};

	> div {
		border-bottom: ${({ responsiveSecondary }) => responsiveSecondary && 'none'};
	}
`;

export const DesktopContainer = styled.div<DesktopContainerStylesProps>`
	position: relative;
	background-repeat: no-repeat;
	background-color: ${({ theme, punchupStyle }) => (punchupStyle ? theme.colors.whitePearl : theme.colors.blackGrey)};
	color: ${({ theme, secondaryStyle, punchupStyle }) =>
		punchupStyle ? theme.colors.black : secondaryStyle ? theme.colors.green : theme.colors.white};
	width: ${({ secondaryStyle }) => (secondaryStyle ? '120px' : '240px')};
	height: 48px;

	font-family: ${({ theme }) => theme.fonts.primary};
	font-weight: 400;
	font-size: 16px;
	box-sizing: border-box;

	&:focus {
		outline: 0;
	}
`;

export const OptionsContainer = styled.div<OptionsContainerStylesProps>`
	display: ${({ isOpened }) => (isOpened ? 'block' : 'none')};
	position: ${({ isLargeScreen }) => (isLargeScreen ? 'relative' : 'absolute')};
	width: ${({ secondaryStyle }) => (secondaryStyle ? '118px' : '240px')};
	background-color: ${({ theme, punchupStyle }) => (punchupStyle ? theme.colors.whitePearl : theme.colors.blackGrey)};
	border: ${({ theme, secondaryStyle, isOpened, punchupStyle }) =>
		punchupStyle
			? `1px solid ${theme.colors.grey20}`
			: isOpened && secondaryStyle
			? `0.5px solid ${theme.colors.green}`
			: `0.5px solid ${theme.colors.white}`};
	border-radius: ${({ isOpened, isLargeScreen }) => (isOpened && isLargeScreen ? '0px 0px 6px 6px' : '6px')};
	box-sizing: border-box;
	right: 0;
	z-index: 1;

	@media screen and (max-width: ${({ theme }) => theme.breakpoints.sm}) {
		width: 210px;
	}
`;

export const Option = styled.div<OptionStylesProps>`
	display: flex;
	height: 35px;
	align-items: center;
	padding: 5px 15px 5px 15px;
	justify-content: flex-start;
	border-bottom: ${({ theme }) => `1px solid ${theme.colors.grey3}`};
	margin: 0;
	gap: 16px;
	cursor: pointer;
	border-radius: 0;
	border-radius: 6px;

	&:hover {
		background-color: ${({ theme, punchupStyle }) => (punchupStyle ? theme.colors.lightGrey7 : theme.colors.grey2)};
	}
`;

export const SecondaryOptionsContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-around;
	height: 30px;
`;

export const SecondaryOption = styled.button<OptionStylesProps>`
	display: flex;
	height: 22px;
	align-items: center;
	border-style: none;
	padding: 5px 15px 5px 15px;
	justify-content: center;
	margin: 0;
	gap: 16px;
	background: ${({ checked, theme }) => (checked ? theme.colors.punchupOrange : 'transparent')};
	margin: ${({ checked }) => checked && '4px'};
	border-radius: 4px;
	color: ${({ theme }) => theme.colors.whitePearl};
	cursor: pointer;
`;
